import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dropdown, Checkbox } from 'semantic-ui-react';

import LanguageService from '../../services/languageService';
import useApiService from '../../services/useApiService';
import useSelectItem from '../project_control_register/use_select_item';
import { getText } from '../../helpers';

import './control_tags_dropdown.css'

const languageService = new LanguageService;

function DropdownItems(props) {
  const {itemClassName, onClickItem, options, selectedItems } = props;

  const getItemClassName = (value) => {
    return selectedItems.includes(value) ? `${itemClassName} active` : itemClassName;
  }

  return (
    <React.Fragment>
      {
        options.map((item)=>{
          return <Dropdown.Item
                  className={getItemClassName(item.value)}
                  onClick={onClickItem}
                  key={item.key}
                  value={item.value}
                  >
                  <Checkbox checked={selectedItems.includes(item.value)} label={item.text}/>
                </Dropdown.Item>
        })
      }
    </React.Fragment>
  )
}

function getValuesFromOptions(options) {
  return options.map(option => option.value);
}

function createOptionsFromArray(array) {
  return array.map((item)=>{
    return {
      key: item.name,
      value: item.name,
      text: item.name,
    }
  })
}

function createNonHeirarchyControlOptions(hierarchyOptions, array) {
  const nonHierarchyItems = array.filter((item)=> !hierarchyOptions.find((option)=>option.value===item.name))
  return createOptionsFromArray(nonHierarchyItems);
}

function ControlTagsDropdown(props) {
  const { translations } = props;
  const libControlTagsPayload = { params: { context: "tags" } };
  const libControlAdminsPayload = { params: { context: "owners" } };
  const [{ response: libControlTags }] = useApiService({ url: `/library_controls/control_tags`, payload: libControlTagsPayload, onMount: true, defaultResponse: [] });
  const [{ response: libControlAdmins }] = useApiService({ url: `/library_controls/control_tags`, payload: libControlAdminsPayload, onMount: true, defaultResponse: []});

  const controlTagOptions = languageService.translateControlTagOptions(translations);
  const controlTagOptionsValues = getValuesFromOptions(controlTagOptions);
  
  const libControlTagOptions = createNonHeirarchyControlOptions(controlTagOptions, libControlTags);
  const libControlTagOptionsValues = getValuesFromOptions(libControlTagOptions);

  const libControlAdminOptions = createOptionsFromArray(libControlAdmins);
  const libControlAdminOptionsValues = getValuesFromOptions(libControlAdminOptions);

  const [selectedControlTags, selectControlTag, filterSelectedControlTags ] = useSelectItem({ defaultValue: [], validItems: controlTagOptionsValues  });
  const [selectedLibControlTags, selectLibControlTag, filterSelectedLibControlTags ] = useSelectItem({ defaultValue: [], validItems: libControlTagOptionsValues  });
  const [selectedLibControlAdmins, selectLibControlAdmin, filterSelectedLibControlAdmins ] = useSelectItem({ defaultValue: [], validItems: libControlAdminOptionsValues  });
  
  const concatenatedTagOptions = controlTagOptions.concat(libControlTagOptions, libControlAdminOptions);
  const selectedTags = selectedControlTags.concat(selectedLibControlTags, selectedLibControlAdmins);

  const onRemoveItem = (evt, data) => {
    filterSelectedControlTags(evt, data);
    filterSelectedLibControlTags(evt, data)
    filterSelectedLibControlAdmins(evt, data);
  }

  useEffect(()=>{
    props.onTagsChange({
      selectedControlTags,
      selectedLibControlTags,
      selectedLibControlAdmins 
    })
  }, [selectedControlTags, selectedLibControlTags, selectedLibControlAdmins])

  return (
    <Dropdown
      className="control-tags-dropdown"
      placeholder={props.placeholder}
      options={concatenatedTagOptions}
      value={selectedTags}
      onChange={onRemoveItem}
      fluid
      multiple
      search
      selection
      closeOnBlur
      closeOnChange
    >
      <Dropdown.Menu>
        <div>
          <Dropdown.Header>{getText("Hierarchy Controls")}</Dropdown.Header>
          <DropdownItems
            itemClassName="control-tag-option"
            onClickItem={selectControlTag}
            options={controlTagOptions}
            selectedItems={selectedControlTags}
          />
        </div>
        <div>
          <Dropdown.Header>{getText("Control Tags")}</Dropdown.Header>
          <DropdownItems
            itemClassName="control-tag-option"
            onClickItem={selectLibControlTag}
            options={libControlTagOptions}
            selectedItems={selectedLibControlTags}
          />
        </div>
        <div>
          <Dropdown.Header>{getText("Control Administrators")}</Dropdown.Header>
          <DropdownItems
            itemClassName="control-tag-option"
            onClickItem={selectLibControlAdmin}
            options={libControlAdminOptions}
            selectedItems={selectedLibControlAdmins}
          />
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )
}

const mapStateToProps = (state) => {
  return {
    translations: state.language.language.translations,
  }
}

export default connect(mapStateToProps, {})(ControlTagsDropdown);


// WEBPACK FOOTER //
// ./src/views/risks_comparison/control_tags_dropdown.js